export const SUPER_ADMIN_ROUTES = {
	ADMIN: 'admin',
	LOGIN_TO_ADMIN_PANEL: 'login',
	LOGIN_TO_PLATFORM: 'login-to-platform',
	LOGOUT: 'logout',
	ME: 'me',
        REFRESH: 'refresh',
        COMPANIES: 'companies',
        FEEDBACKS: 'feedbacks',
        UPGRADE_REQUESTS: 'plan-upgrade-requests',
	// 
	CREATE_PREBUILD_TECHNOLOGY: 'create-prebuild-technology',
	DELETE_PREBUILD_TECHNOLOGY: 'delete-prebuild-technology',
	AUTO_CREATOR: 'auto-creator',
	UTILS: {
		PRESET_TECHNOLOGIES: 'utils/get-all-preset-technologies-list',
        DELETE_COMPANY: 'utils/delete-company',
        DELETE_COMPANY_TEST_REQUEST: 'utils/delete-company-test-request',
        CHANGE_COMPANY_TIER: 'utils/change-company-tier',
        },
} as const
// auto-creator
export const getAutoCreatorDashboardUrl = (): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.AUTO_CREATOR}/dashboard`
}

export const getAutoCreatorBatchUrlPost = (): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.AUTO_CREATOR}/batch`
}

export const getAutoCreatorPatchStoryUrlPatch = (): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.AUTO_CREATOR}/patch-story-url`
}
export const getAdminAutoDeleteFailedCompany = (id: string): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.AUTO_CREATOR}/delete-failed-company/${id}`
}
export const getAdminAutoCleanupGroupPost = (): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.AUTO_CREATOR}/cleanup-group`
}


// 
export const getLoginToAdminPanelUrlPost = (): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.LOGIN_TO_ADMIN_PANEL}`
}
export const getLogoutFromAdminPanelUrlPost = (): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.LOGOUT}`
}
export const getLoginToPlatformUrlPost = (): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.LOGIN_TO_PLATFORM}`
}
export const getAdminRefreshTokenUrlPost = (): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.REFRESH}`
}
export const getAdminMeUrl = (): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.ME}`
}
export const getAdminCompaniesUrl = (): string => {
        return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.COMPANIES}`
}
export const getAdminAutoCreatorDashboardFriendlyUrl = (): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/auto-creator/dashboard-friendly`
}
export const getAdminFeedbackCountersUrl = (): string => {
        return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.FEEDBACKS}/counters`
}
export const getAdminFeedbacksPendingAdminUrl = (): string => {
        return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.FEEDBACKS}/pending-admin`
}
export const getAdminFeedbacksPendingClientUrl = (): string => {
        return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.FEEDBACKS}/pending-client`
}
export const getAdminFeedbacksConfirmedUrl = (): string => {
        return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.FEEDBACKS}/confirmed`
}
export const getAdminFeedbackConfirmUrlPost = (id: string): string => {
        return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.FEEDBACKS}/${id}/confirm`
}
export const getAdminFeedbackRejectUrlPost = (id: string): string => {
        return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.FEEDBACKS}/${id}/reject`
}
export const getAdminCreatePrebuildTechnologyUrl = (): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.CREATE_PREBUILD_TECHNOLOGY}`
}

export const getAdminDeletePrebuildTechnologyUrl = (id: string): string => `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.DELETE_PREBUILD_TECHNOLOGY}/${id}`

export const getAdminGetAllPresetTechnologiesUrl = (): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.UTILS.PRESET_TECHNOLOGIES}`
}
export const getAdminDeleteCompanyUrl = (): string => {
        return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.UTILS.DELETE_COMPANY}`
}
export const getAdminChangeCompanyTierUrl = (): string => {
        return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.UTILS.CHANGE_COMPANY_TIER}`
}

export const getAdminUpdateCompanyNameUrlPatch = (companyId: string): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.COMPANIES}/${companyId}/name`
}

// plan upgrade requests (admin)
export const getAdminUpgradeRequestsAwaitingUrl = (): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.UPGRADE_REQUESTS}/awaiting`
}
export const getAdminUpgradeRequestsResolvedUrl = (): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.UPGRADE_REQUESTS}/resolved`
}
export const getAdminUpgradeRequestResolveUrlPost = (id: string): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.UPGRADE_REQUESTS}/${id}/resolve`
}
export const getAdminUpgradeRequestsCountersUrl = (): string => {
	return `/${SUPER_ADMIN_ROUTES.ADMIN}/${SUPER_ADMIN_ROUTES.UPGRADE_REQUESTS}/counters`
}
// export const getTeamMainUrl = (): string => {
// 	return `/${COMMON_ROUTES.TEAM}`
// }
// export const getTeamMainUrlPost = (): string => {
// 	return `/${COMMON_ROUTES.TEAM}`
// }
// export const getTeamMemberUpdateUrlPost = (teamMemberId: string): string => {
// 	return `/${COMMON_ROUTES.TEAM}/${COMMON_ROUTES.TEAM_MEMBER}/${teamMemberId}`
// }
// export const getTeamMemberCreateNewUrlPost = (): string => {
// 	return `/${COMMON_ROUTES.TEAM}/${COMMON_ROUTES.TEAM_MEMBER}/${COMMON_ROUTES.NEW_MEMBER}`
// }
// export const getTeamMemberDeleteUrl = getTeamMemberUpdateUrlPost
// export const getAllTeamMembers = (): string => {
// 	return `/${COMMON_ROUTES.TEAM}/${COMMON_ROUTES.TEAM_MEMBER}`
// }

// export const getTechnologyUpdateUrlPost = (technologyId: string): string => {
// 	return `/${COMMON_ROUTES.TECHNOLOGY}/${technologyId}`
// }
// export const getTechnologyDeleteUrl = getTechnologyUpdateUrlPost
// export const getAllTechnologies = (): string => {
// 	return `/${COMMON_ROUTES.TECHNOLOGY}`
// }
// export const getAllPresetTechnologies = (): string => {
// 	return `/${COMMON_ROUTES.TECHNOLOGY}/${COMMON_ROUTES.PRESET_TECHNOLOGY}`
// }
// export const getAllCompanyAndPresetTechnologies = (): string => {
// 	return `/${COMMON_ROUTES.TECHNOLOGY}/${COMMON_ROUTES.ALL_TECHNOLOGY}`
// }
// export const getAllInvitations = (): string => {
// 	return `/${COMMON_ROUTES.INVITATION}`
// }
// export const getInvitationUrlPost = (): string => {
// 	return `/${COMMON_ROUTES.INVITATION}`
// }
// export const getInvitationAcceptUrlPost = (): string => {
// 	return `/${COMMON_ROUTES.INVITATION}/${COMMON_ROUTES.ACCEPT_INVITATION}`
// }
// export const getInvitationCheckUrlPost = (): string => {
// 	return `/${COMMON_ROUTES.INVITATION}/${COMMON_ROUTES.CHECK_INVITATION}`
// }
// export const getInvitationDeleteUrl = (): string => {
// 	return `/${COMMON_ROUTES.INVITATION}`
// }
// export const getInvitationResendUrlPost = (): string => {
// 	return `/${COMMON_ROUTES.INVITATION}/${COMMON_ROUTES.RESEND}`
// }
// // export const getAllStoryTechnologies = (storyId: string): string => {
// // 	return `/${COMMON_ROUTES.TECHNOLOGY}/${COMMON_ROUTES.ALL_TECHNOLOGY}`
// // }
// // export const getAllStories = (): string => {
// // 	return `/${STORY_ROUTES.BASE}/${STORY_ROUTES.ALL_STORIES}`
// // }

// // export const getStoryProjectUrlPost = (storyId: string): string => {
// // 	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.PROJECT}`
// // }
// // export const getStoryClientUrlPost = (storyId: string): string => {
// // 	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.CLIENT}`
// // }
